import { SortingState } from "@tanstack/react-table";
import identity from "lodash/identity";
import { calculateOrderUpdate, getSelectedSort } from "PFApp/hooks/table/helpers";
import {
  ApiOrderKeyToColumnNamesFormatter,
  ColumnNameToApiOrderKeyFormatter
} from "PFApp/hooks/table/table.types";
import { OrderMeta, OrderOption } from "PFTypes";
import { useCallback } from "react";

type UseTableSorting = {
  setParamsOrder: (key: string, order: OrderOption | undefined) => void;
  parseMetaOrderName?: ApiOrderKeyToColumnNamesFormatter;
  parseTableSortingId?: ColumnNameToApiOrderKeyFormatter;
};

export type UseChildrenTableSortingReturn = {
  getSorting: (metaOrder: OrderMeta | undefined) => SortingState;
  handleSortingChange: (key: string, newSorting: SortingState, metaOrder: OrderMeta | undefined) => void;
};

export const useChildrenTableSorting = ({
  setParamsOrder,
  parseMetaOrderName = identity,
  parseTableSortingId = identity
}: UseTableSorting): UseChildrenTableSortingReturn => {
  const getSorting = useCallback(
    (metaOrder: OrderMeta | undefined) => getSelectedSort(metaOrder?.value, parseMetaOrderName),
    [parseMetaOrderName]
  );

  const handleSortingChange = useCallback(
    (key: string, newSorting: SortingState, metaOrder: OrderMeta | undefined) => {
      const updatedOrder = calculateOrderUpdate({
        defaultOrder: metaOrder?.defaultValue,
        selectedApiOrder: metaOrder?.value,
        options: metaOrder?.options || [],
        parseTableSortingId,
        parseMetaOrderName,
        newSorting
      });
      setParamsOrder(key, updatedOrder);
    },
    [parseMetaOrderName, parseTableSortingId, setParamsOrder]
  );

  return {
    getSorting,
    handleSortingChange
  };
};
